import { useEffect, useState } from "react";

const CheckboxEntry = (props) => {
  const { item, handleCheckboxChange, refresh, key, formType } = props;
  const [isRiskAnalysis, setIsRiskAnalysis] = useState(false);

  var _defaultValue =
    item.value.toLowerCase() === "true" || item.value === "1" ? true : false;
  const [check, setCheck] = useState(_defaultValue);
  useEffect(() => {
    setIsRiskAnalysis(
      formType === "edit" && item.code === "RiskAnalysis" && _defaultValue,
    );
  }, []);

  return (
    <div className="form-group" key={item.standardAttributId}>
      <label className="">
        {item.bezeichnung.trim()}
        {item.mandatoryField ? (
          <>
            <span className="requiredCls"></span>
          </>
        ) : (
          <></>
        )}
      </label>
      <div className="col-sm-2">
        <label className="checkbox-inline">
          <input
            type="checkbox"
            name={item.bezeichnung}
            disabled={!item.editbarFeld || isRiskAnalysis}
            id={item.standardAttributId}
            key={item.standardAttributId}
            defaultChecked={check}
            onChange={(e) => {
              setCheck(e.target.checked);
              handleCheckboxChange(e.target.checked, item.tracker, item.code);
            }}
          />
          <span className="input-checkbox"></span>
        </label>
      </div>
    </div>
  );
};
export default CheckboxEntry;
